import { createSelector } from "reselect";

export const selectRouterState = createSelector(
    [(state) => state]
    , (state) => state.router ?? {}
)

export const selectHistory = createSelector([selectRouterState], state => state.history)